import { Tooltip } from "recharts";

const BaseChartTooltip = Tooltip

export default BaseChartTooltip;